export const routeConfig = {
  meta: {
    title: '申请融资',
  },
};
